/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Source_RemoveInputs */

const vi_pll_new_source_remove = /** @type {(inputs: Pll_New_Source_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá lô nguồn`)
};

/**

* @param {Pll_New_Source_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_source_remove = /** @type {((inputs?: Pll_New_Source_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Source_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_source_remove(inputs)
});